import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Container from '../Container';
import './index.scss';
import { svgSprite } from './svgSpriteForSrp';
import DownloadPopup from './DownloadPopup';
import { setPreloader } from './setPreloader';
import LINKED_CONNECTIONS_TYPES from './linked-connection-types.json';

const { CancelToken } = axios;
let cancelLoadDownloadPopup;

const findElementUp = (el, pr) =>
    pr(el) ? el : (el.parentElement && findElementUp(el.parentElement, pr)) || null;

const wrapperSvg = document.createElement('div');
wrapperSvg.innerHTML = svgSprite;
document.body.appendChild(wrapperSvg);
function closeSortDropDowns() {
    const dd = Array.from(document.querySelectorAll('.sorting-search-results_dropdown'));
    dd.forEach(el => {
        el.classList.remove('open');
        Array.from(el.querySelectorAll('.filter-list__btn, .filter-list__item-content')).forEach(
            item => {
                item.classList.remove('open');
            },
        );
    });
}
const handlerHybridOutlets = target => {
    let ajaxParamLastPart;
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(LINKED_CONNECTIONS_TYPES)) {
        if (target.parentNode.getAttribute('data-item-name') === key && target.checked) {
            const linkedInput = document.querySelector(`div[data-item-name='${value}'] > input`);
            if (
                linkedInput &&
                linkedInput.hasAttribute('data-ajax-param') &&
                !linkedInput.checked
            ) {
                linkedInput.checked = true;
                const index = linkedInput.getAttribute('data-ajax-param').split('Z').length - 1;
                ajaxParamLastPart = linkedInput.getAttribute('data-ajax-param').split('Z')[index];
                break;
            }
            break;
        }
    }
    return ajaxParamLastPart;
};
function getHandler(updateApp, handlerDownloadButton) {
    function handler(e) {
        const clearFilters = findElementUp(e.target, el => el.id === 'clearFilters');
        if (clearFilters) {
            e.preventDefault();
            const url = window.location.pathname;
            const path = url.split('/').filter((item, index) => index > 4);
            const categoryId = path
                .pop()
                .replace('N-', '')
                .split('Z')[0];
            updateApp(`/${path.join('/')}/N-${categoryId}`);
            return;
        }
        const downloadButton = findElementUp(e.target, el =>
            el.classList.contains('has-option-download'),
        );
        if (downloadButton) {
            e.preventDefault();
            handlerDownloadButton(downloadButton);
        }
        const withAjax = findElementUp(e.target, el => el.hasAttribute('data-ajax-param'));
        if (withAjax) {
            if (withAjax.classList.contains('pagination-apc__pager-item')) e.preventDefault();

            const fullUrl = withAjax.getAttribute('data-ajax-param');
            let [url, search] = fullUrl.split('?');
            const isCategory = withAjax.classList.contains('category-facet');
            const isRedirect = withAjax.getAttribute('data-external');
            const linkedAjaxParam = handlerHybridOutlets(withAjax);
            url += linkedAjaxParam ? `Z${linkedAjaxParam}` : '';
            if (isCategory && isRedirect === 'true') {
                window.open(fullUrl, '_self');
                return;
            }
            if (isCategory && url) {
                const path = url.split('/');
                const idBlock = path.pop();
                const ids = idBlock.replace('N-', '').split('Z');
                ids.unshift(ids.pop());
                url = [...path, `N-${ids.join('Z')}`].join('/');
            }
            if (!url || !search) {
                search = '';
            }
            url += search ? `?${search}` : '';
            const justAppend = withAjax.classList.contains('pagination-apc__show-more');
            updateApp(url, justAppend);
            return;
        }
        const btn = findElementUp(e.target, el => el.classList.contains('filter-list__btn'));
        if (btn) {
            if (!btn.parentElement.classList.contains('sorting-search-results_dropdown')) {
                closeSortDropDowns();
            }
            btn.parentElement.classList.toggle('open');
            Array.from(
                btn.parentElement.querySelectorAll('.filter-list__btn, .filter-list__item-content'),
            ).forEach(item => {
                item.classList.toggle('open');
            });
        } else {
            closeSortDropDowns();
        }
        const showMore = findElementUp(e.target, el =>
            el.classList.contains('filter-list__show-more'),
        );
        const openFilters = findElementUp(e.target, el =>
            el.classList.contains('js-toggle-open-btn'),
        );
        if (openFilters) {
            openFilters.classList.toggle('open');
            openFilters.parentElement.classList.toggle('open');
            openFilters.parentElement
                .querySelector('.mobile-list-btn-content')
                .classList.toggle('open');
        }
        if (showMore) {
            const [show, less] = [
                showMore.getAttribute('data-show-more'),
                showMore.getAttribute('data-show-less'),
            ];
            showMore.innerHTML = showMore.innerHTML === show ? less : show;
            showMore.parentElement.classList.toggle('show-more-items');
        }
    }
    return handler;
}
let handler;
class SRPContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataPopup: null,
        };
    }
    loadDownloadPopup(element) {
        if (cancelLoadDownloadPopup) {
            cancelLoadDownloadPopup();
        }
        const commonData = element.dataset;
        const preloader = setPreloader(element);
        axios
            .get(
                `/rest/model/schneider/catalog/CatalogLookupActor/softwareDownloads?skuId=SKU-${commonData.partnumber}&pushSite=${commonData.pushsite}`,
                {
                    cancelToken: new CancelToken(cancelFunction => {
                        cancelLoadDownloadPopup = cancelFunction;
                    }),
                },
            )
            .then(result => {
                cancelLoadDownloadPopup = null;
                preloader.destroy();
                this.setState({ dataPopup: { ...result.data, ...commonData } });
                document.body.classList.add('modal-open');
            })
            .catch(() => {
                preloader.destroy();
            });
    }
    componentDidMount() {
        const { updateApp } = this.props;
        const handlerDownloadButton = element => {
            this.loadDownloadPopup(element);
        };
        handler = getHandler(updateApp, handlerDownloadButton);
        document.body.addEventListener('click', handler);
    }
    componentWillUnmount() {
        document.body.removeEventListener('click', handler);
    }
    render() {
        const { srp } = this.props;
        return (
            <Container>
                {this.state.dataPopup ? (
                    <DownloadPopup
                        closePopup={() => {
                            document.body.classList.remove('modal-open');
                            this.setState({ dataPopup: null });
                        }}
                        data={this.state.dataPopup}
                    />
                ) : null}
                <div className="js-srp-mediator-outer" dangerouslySetInnerHTML={{ __html: srp }} />
            </Container>
        );
    }
}
SRPContainer.propTypes = {
    srp: PropTypes.string.isRequired,
    updateApp: PropTypes.func.isRequired,
};
export default SRPContainer;
